import * as React from "react";
import { useEffect, useState } from "react";
import { getAdminComments, deleteAdminComment, createAdminComment } from "../../../../api/sdk.gen";
import { Comment } from "../../../../api/types.gen";
import { formatDate } from '../../../../helpers/dates'
import MySwal from "../../../../ui/MySwal";

interface CommentsProps {
  questionId: number;
  userContext: UserContext;
}

const Comments: React.FC<CommentsProps> = ({ questionId, userContext }) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [newComment, setNewComment] = useState<string>("");

  const fetchComments = async () => {
    try {
      const resp = await getAdminComments({
        query: { filters: { commentable_id: questionId, commentable_type: 'Assessment::Question' }, per: 1000 },
      });
      setComments(resp.data.data);
    } catch (error) {
      console.error("Failed to fetch comments:", error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [questionId]);

  const handleDeleteComment = async (id: number) => {
    const confirmDelete = await MySwal.fire({
      title: "Are you sure you want to delete suggestion?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (confirmDelete.isConfirmed) {
      const result = await deleteAdminComment({ path: { id }});

      if (result.error) {
        MySwal.fire("Error!", `Failed to delete suggestion. ${(result as { error: { error: string } }).error.error}`, "error");
      } else {
        fetchComments()
        MySwal.fire("Deleted!", "Suggestion have been deleted.", "success");
      }
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    try {
      const resp = await createAdminComment({
        body: {
          body: newComment,
          commentable_id: questionId,
          commentable_type: 'Assessment::Question',
        }
      });
      setComments((prev) => [...prev, resp.data]);
      setNewComment("");
    } catch (error) {
      console.error("Failed to add comment:", error);
    }
  };

  const canRemoveComment = (comment: Comment) => {
    const { isAdmin, id: userId } = userContext;
    return isAdmin || userId == comment.user_id;
  }

  return (
    <div className="comments-container">
      <div className="comments-list">
        <h3>Edit suggestions</h3>
        {comments.map((comment) => (
          <div key={comment.id} className="comment">
            { canRemoveComment(comment) &&
              <button className="delete-button" onClick={() => handleDeleteComment(comment.id)}>✕</button> }
            <div className="comment-header">
              <span className="comment-user">{comment.user_name}</span>
              <span className="comment-date">{formatDate(comment.created_at, 'MM-DD-YYYY HH:mm')}</span>
            </div>
            <div className="comment-body">{comment.body}</div>
          </div>
        ))}
      </div>
      <div className="comment-form">
        <div className="comment-form-header">Add Comment</div>
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Write a comment..."
          className="comment-input"
        />
        <button
          onClick={handleAddComment}
          className="submit-button"
          disabled={!newComment.trim()}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default Comments;
